// extracted by mini-css-extract-plugin
export default {"country":"styles_country__IPpS9","main_section":"styles_main_section__P-ckt","left_banner":"styles_left_banner__sqv7s","right_section":"styles_right_section__6rFsq"};